import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import { NotificationContainer } from '../../Utils/notification';

import '../../styles/local.css';
import '../../styles/backoffice.css';

export default function BackofficeLayout() {
  return (
    <div className="backoffice-container">
      <NotificationContainer />
      <Sidebar />

      <section className="backoffice-content">
        <Suspense fallback={<div>Carregando...</div>}>
          <Outlet />
        </Suspense>
      </section>
    </div>
  );
}
